import React from 'react';
import HubErrorPage from '../components/common/HubErrorPage';

function NotFoundPage() {
  return (
    <div data-testid="not-found-page">
      <HubErrorPage type="not_found" variant="shell" />
    </div>
  );
}

export default NotFoundPage;
